import React from 'react';
import type TTabPanel from './types/TTabPanel';
import Box from '../Box/Box';

const TabPanel = ({ children, activeTab, tab, ...otherProps }: TTabPanel) => {
  return activeTab === tab ? (
    <Box as="section" name="TabPanelNext" {...otherProps}>
      {children}
    </Box>
  ) : null;
};

export default TabPanel;
